import type Owner from '@ember/owner';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsDatasetsComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'Advanced analytics capabilities with custom-built datasets';
		this.descText =
			'Create and hand-pick properties from data sources with replicated data, that will allow you to view, filter, export and merge raw data.';
		this.readMoreUrl = 'https://help.databox.com/understanding-datasets';
		this.topImageLightUrl = '/images/placeholders/datasets.svg';
		this.topImageDarkUrl = '/images/placeholders/datasets.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-datasets.svg';
		this.videoUrl = 'https://player.vimeo.com/video/1099367921';
		this.imageHeight = 548;

		this.trackingOrigin = 'datasets';
	}

	override get createButtonText(): string {
		return 'New dataset';
	}
}
